import moment from "moment-timezone";

import { OutputRow as MeetingRescheduleRequestsData } from "api/getMeetingRescheduleRequests";
import { formatBasicMeetingDetails } from "services/formatBasicMeetingDetails";

export function formatMeetingRescheduleRequestDetails(
	event: MeetingRescheduleRequestsData,
	currentUid: string,
	useShortFormat: boolean,
	timezone: string
) {
	const { originalDateStartsUTC, originalDateEndsJustBeforeUTC } = event;

	const originalStart = moment(originalDateStartsUTC).tz(timezone);
	const originalEnd = moment(originalDateEndsJustBeforeUTC).tz(timezone);

	const formatStringDate = useShortFormat ? "YYYY/MM/DD" : "dddd MMMM Do YYYY";
	const formatStringTime = "HH:mm";

	return {
		...formatBasicMeetingDetails(event, currentUid, useShortFormat, timezone),
		originalStartDate: originalStart.format(formatStringDate),
		originalStartTime: originalStart.format(formatStringTime),
		originalEndTime: originalEnd.format(formatStringTime)
	};
}
